export interface AlbumMeta {
  name: string;
  year: string;
  prompt: string;
  cover: string;
}

export const ALBUMS: AlbumMeta[] = [
  { name: "五月天第一张创作专辑", year: "1999", prompt: "从最初的声音里，选一首仍会让你回头的歌。", cover: "/albums/01.jpg" },
  { name: "爱情万岁", year: "2000", prompt: "当关系有了重量，哪一种感受更接近你？", cover: "/albums/02.jpg" },
  { name: "人生海海", year: "2001", prompt: "世界开始变大以后，哪首歌更接近你的回答？", cover: "/albums/03.jpg" },
  { name: "时光机", year: "2003", prompt: "时间往前走，哪一段仍与你并肩？", cover: "/albums/04.jpg" },
  { name: "神的孩子都在跳舞", year: "2004", prompt: "在速度与碰撞之间，选出最像你的一首。", cover: "/albums/05.jpg" },
  { name: "为爱而生", year: "2006", prompt: "相信、失去与继续，你更愿意带走哪一句？", cover: "/albums/06.jpg" },
  { name: "后青春期的诗", year: "2008", prompt: "青春没有结束，只是换了说法。", cover: "/albums/07.jpg" },
  { name: "第二人生", year: "2011", prompt: "如果可以再选一次，你会把哪首歌留给明天？", cover: "/albums/08.jpg" },
  { name: "自传", year: "2016", prompt: "走过以后回头看，哪首歌最像你的注脚？", cover: "/albums/09.jpg" }
];

export const albumByName = new Map(ALBUMS.map((album) => [album.name, album]));
